import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./User.module.sass";
import connectWalletStyle from "../Header.module.sass";
import Icon from "../../Icon";
import Theme from "../../Theme";
import Modal from "../../NewModal";
import Dropdown from "../../Dropdown";
import {
  createBuyerUser,
  CreateRefrerral,
  verifyBuyerAddress,
} from "../../../services/ApiServices";
import TextInput from "../../TextInput";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { ethers, providers } from "ethers";
import { getUser } from "../../../redux";
import { useWeb3React } from "@web3-react/core";
import { minifyAddress } from "../../../utils/helpers";
import { useActiveWeb3React } from "../../../hooks/index.ts";
import { toDisplay } from "../../../utils/helpers";
import EtheriumImg from "../../../images/Ethereum.png";
import PolygonImg from "../../../images/polygon.png";
import Avatar from "../../../images/avatar.png";
import { isMobile } from "react-device-detect";
import { Tooltip } from "antd";
import ERC20 from "../../../abi/ERC20.json";
import BonezImg from "../../../images/bonez.png";
import AvatarIcon from "../../../images/avatarIcon.png";
import DisconnectIcon from "../../../images/disconnect.png";
import { ALCHEMY_PROVIDER_KEY } from "../../../Config/config";
import Stake from "../Stake";
import PrimaryButton from "../../PrimaryButton";
import { useNavigate } from "react-router-dom";
import BlackModal from "../../BlackModal";
import { useSearchParams } from "react-router-dom";

const User = ({ className, refresh, stick, connect, logout }) => {
  const state = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [isSelectWallet, setIsSelectWallet] = useState(false);
  const [user, setUser] = useState({});
  const [bonezBalance, setBonezBalance] = useState(0);
  const [name, setName] = useState(localStorage.getItem("userName"));
  const [nftAddress, setNftAddress] = useState(
    localStorage.getItem("nftAddress")
  );
  const navigate = useNavigate();
  const [uid, setUid] = useState(localStorage.getItem("uid"));

  const { account, active, activate, error, deactivate } = useWeb3React();
  const [balance, setBalance] = useState(0);
  const [isStakeModal, setIsStakeModal] = useState(false);
  const [referralId, setReferralId] = useState("");
  const [isCreated,setIsCreated] = useState(false)
  let [searchParams] = useSearchParams();

  const { library, chainId } = useActiveWeb3React();
  // const { library } = useWeb3React();
  const getBalance = useCallback(async () => {
    const balance = await library?.getBalance(account);
    if (typeof balance === "undefined") {
      return;
    }
    setBalance(toDisplay(balance));
  }, [account, library]);
  useEffect(()=>{
    if (searchParams.get("referralId")) {
      setReferralId(searchParams.get("referralId"));
    }
  },[searchParams.get("referralId")])
  useEffect(() => {

    if (referralId && active && !isCreated) createUser();
  }, [active,referralId,account]);

  const createUser = async () => {
    let result;
    let body = {
      id: account,
      referralId: referralId,
    };
    try {
      result = await CreateRefrerral(body);
    } catch (e) {
      console.log(e.message);
      if(e.message=='You are already Registered'){
        userDetails(account)
      }
    }
    try {
      if (result.success) {
        setIsCreated(true)
        userDetails(account)
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (active) {
      getBalance();
    }
  }, [active, getBalance, library]);

  const items = [
    {
      title: "My Account",
      icon: AvatarIcon,
      url: "/profile/" + account?.toString(),
      subMenu: false,
    },
    {
      title: "Bank",
      url: "/bank",
      subMenu: true,
    },
    {
      title: "Stake",
      subMenu: true,
    },
    {
      title: "Disconnect",
      icon: DisconnectIcon,
      subMenu: false,
    },
  ];
  useEffect(() => {
    setUser(state.User.user);
    if (state.User.user) {
      setName(state.User.user.userName);
      setNftAddress(state.User.user.walletAddress);
      setUid(state.User.user._idid);
    }
  }, [state.User.user]);

  useEffect(() => {
    if (account && !referralId) userDetails(account);
  }, [account,referralId]);

  useEffect(() => {
    setName(localStorage.getItem("userName"));
  }, [visible]);

  const userDetails = async (uid) => {
    dispatch(getUser(uid));
  };

  useEffect(() => {
    if (account && chainId == 137) CheckBalance();
  }, [account, chainId]);
  const CheckBalance = async () => {
    let balanceval = 0;
    try {
      const provider = new providers.AlchemyProvider(
        "matic",
        ALCHEMY_PROVIDER_KEY
      );
      const cyberdogzMarket = new ethers.Contract(
        "0xcF79651fBae99559127764a5ab808747fa3391ce",
        ERC20,
        provider
      );
      let ahtbalance = await cyberdogzMarket.balanceOf(account);
      balanceval = parseFloat(ethers.utils.formatEther(ahtbalance));
      setBonezBalance(balanceval);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {active ? (
        <div className={styles.user}>
          {/* <div className={styles.avatar}>
            <img src={user?.profileUrl ? user.profileUrl : Avatar} onClick={() => setVisible(!visible)} />
          </div> */}
          {/* {name ? ( */}
          <PrimaryButton
            className={styles.head}
            label={minifyAddress(account, 6)}
            onClick={() => navigate("/profile")}
          >
            {/* <div className={styles.walletname}>
              {minifyAddress(account, 6)}{" "}
              <span className={styles.currency}></span>
            </div> */}
          </PrimaryButton>
          {/* ) : (
            <button
              className={cn("button", styles.button)}
              onClick={() => {
                setIsSelectWallet(true);
              }}
            >
              Connect Wallet
            </button>
          )} */}
          {visible && (
            <div className={stick ? styles.stickBody : styles.body}>
              {/* <div className={styles.name}>{name}</div> */}
              <div className={styles.code}>
                <div className={styles.number}>{minifyAddress(account, 8)}</div>
                <Tooltip title="Copied!" color="#04DFE5" trigger="click">
                  <button
                    className={styles.copy}
                    onClick={() => {
                      navigator.clipboard.writeText(account);
                    }}
                  >
                    <Icon name="copy" size="16" />
                  </button>
                </Tooltip>
              </div>
              <div className={styles.wrap}>
                <div className={styles.line}>
                  <div className={styles.preview}>
                    <img
                      src={chainId == 137 ? PolygonImg : EtheriumImg}
                      alt="Etherium"
                    />
                  </div>
                  <div className={styles.details}>
                    <div className={styles.info}>Balance</div>
                    <div className={styles.price}> {balance}</div>
                  </div>
                </div>
                {chainId == 137 && (
                  <div className={styles.line}>
                    <div className={styles.preview}>
                      <img src={BonezImg} alt="Bonez" />
                    </div>
                    <div className={styles.details}>
                      <div className={styles.info}>Balance</div>
                      <div className={styles.price}>
                        {" "}
                        {bonezBalance.toFixed(2)}
                      </div>
                    </div>
                  </div>
                )}
                {/* {nftAddress&&
                <button
                  className={cn("button", styles.button)}
                  onClick={() => {
                    setIsSelectWallet(true);
                  }}
                >
                  Connect Wallet
                </button>} */}
                {/* <Link to={"/login"}>
              <button
                className={cn("button", styles.button)}
              >
                Login
              </button>
              </Link> */}
              </div>
              <div className={styles.menu}>
                {items.map((x, index) =>
                  x.url ? (
                    x.subMenu ? (
                      <Link
                        className={styles.subMenu}
                        to={x.url}
                        onClick={() => setVisible(!visible)}
                        key={index}
                      >
                        <div className={styles.text}>{x.title}</div>
                      </Link>
                    ) : user._id ? (
                      <Link
                        className={styles.item}
                        to={x.url}
                        onClick={() => setVisible(!visible)}
                        key={index}
                      >
                        <div className={styles.icons}>
                          <img src={x.icon} className={styles.icons} />
                        </div>
                        <div className={styles.text}>
                          {x.title}
                          {}
                        </div>
                      </Link>
                    ) : (
                      <Link
                        className={styles.item}
                        to={x.url}
                        onClick={() => setVisible(!visible)}
                        key={index}
                      >
                        <div className={styles.icons}>
                          <img src={x.icon} className={styles.icons} />
                        </div>
                        <div className={styles.text}>
                          {x.title}
                          {}
                        </div>
                      </Link>
                    )
                  ) : x.title == "Disconnect" ? (
                    <>
                      <div className={styles.hr}></div>
                      <div
                        className={styles.item}
                        key={index}
                        onClick={() => logout()}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={styles.icons}>
                          <img src={x.icon} className={styles.icons} />
                        </div>
                        <div className={styles.text}>{x.title}</div>
                      </div>
                    </>
                  ) : (
                    <button
                      className={styles.subMenu}
                      onClick={() => {
                        setIsStakeModal(true);
                        setVisible(!visible);
                      }}
                    >
                      <div className={styles.text}>Stake</div>
                    </button>
                  )
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div
            className={styles.avatar}
            onClick={() => {
              setIsSelectWallet(true);
            }}
          >
            <img src={Avatar} />
          </div>
          <PrimaryButton
            className={styles.head}
            onClick={() => {
              setIsSelectWallet(true);
            }}
            label="CONNECT WALLET"
          >
            {/* <div className={styles.walletname}>CONNECT WALLET</div> */}
          </PrimaryButton>
        </>
      )}
      <BlackModal
        visible={isSelectWallet}
        onClose={() => setIsSelectWallet(false)}
        outerClassName={styles.outermodal}
      >
        <div className={styles.modal}>
          <div className={styles.wallethead}>Connect Wallet</div>
          <br />
          <div className={styles.text}>
            Please connect your wallet to continue.
            <br /> The system supports the following wallets
            <br />
            <br />
          </div>
          <div
            className={styles.wallet}
            onClick={() => {
              if (isMobile && !window.ethereum) {
                window.location = "https://metamask.app.link/dapp/cyberdogz.io";
              } else {
                connect();
                setIsSelectWallet(false);
              }
            }}
          >
            <img
              className={styles.metamask}
              src="data:image/svg+xml;base64,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"
            />
            MetaMask
            <img
              className={styles.iconimg}
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAyMTUgOC42NDVMMTUuMzY0OCAxNEwxMC4wMjE1IDE5LjM1NUwxMS42NjY1IDIxTDE4LjY2NjUgMTRMMTEuNjY2NSA3TDEwLjAyMTUgOC42NDVaIiBmaWxsPSIjNzc3RTkwIi8+Cjwvc3ZnPgo="
            />
          </div>
        </div>
      </BlackModal>
      <Modal
        visible={isStakeModal}
        onClose={() => setIsStakeModal(false)}
        close={styles.close}
        containerClassName={styles.modalContainer}
      >
        <Stake />
      </Modal>
    </OutsideClickHandler>
  );
};

export default User;
